import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../src/locales/en.json';
import deTranslations from '../src/locales/de.json';
import cnTranslations from '../src/locales/cn.json';
import dkTranslations from '../src/locales/dk.json';
import itTranslations from '../src/locales/it.json';
import gbTranslations from '../src/locales/gb.json';

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  },
  cn: {
    translation: cnTranslations
  },
  dk: {
    translation: dkTranslations 
  },
  it: {
    translation: itTranslations 
  },
  gb: {
    translation: gbTranslations 
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Default language
  interpolation: {
    escapeValue: false // React already does escaping
  }
});

export default i18n;
